import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateAssetStatus } from '../../../../state';

const ExpectedLifespanEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentAsset } = useAppSelector(state => state.asset);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateAssetStatus({ expectedLifespan: event.target.value }));
  };

  return (
    <TextField
      label="Expected Lifespan"
      size="small"
      fullWidth
      value={currentAsset?.expectedLifespan || ''}
      onChange={handleChange}
      placeholder="e.g., 10 years"
    />
  );
};

export default ExpectedLifespanEdit;
